import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Emit, Prop, PropSync, Vue } from 'vue-property-decorator';
import { ProductApi } from "@/apis";
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 編集対象 */
        _this.product = null;
        return _this;
    }
    Product.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, new ProductApi().getProductPublic({
                                id: this.productId,
                                corporateId: this.corporateId
                            }).then(function (res) { return res.data; })];
                    case 1:
                        _a.product = (_b.sent()) || {};
                        return [2 /*return*/];
                }
            });
        });
    };
    Product.prototype.apply = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    __decorate([
        Prop()
    ], Product.prototype, "corporateId", void 0);
    __decorate([
        Prop()
    ], Product.prototype, "productId", void 0);
    __decorate([
        PropSync('target', { type: Object })
    ], Product.prototype, "product", void 0);
    __decorate([
        Emit('applied')
    ], Product.prototype, "apply", null);
    Product = __decorate([
        Component({})
    ], Product);
    return Product;
}(Vue));
export default Product;
